import React from 'react'
import githubIcon from '../Assets/github.svg';
import notionIcon from '../Assets/notion.svg';
import '../Styles/navbar.css'

const Navbar = () => {
    return (
        <section className='navbar-section'>
            <header className='header'>
                <div className='nav-div'>
                    <a href='#home' data-replace="HOME"><span>HOME</span></a>
                    <a href='#about' data-replace="ABOUT"><span>ABOUT</span></a>
                    <a href='#skills' data-replace="SKILLS"><span>SKILLS</span></a>
                    <a href='#projects' data-replace="PROJECTS"><span>PROJECTS</span></a>
                    {/* <a href='#contact' data-replace="CONTACT"><span>CONTACT</span></a> */}
                </div>
                <div className="icon-div">
                    <a href='https://github.com/hong-sehyun' className='icon' ><img src={githubIcon} alt='github' /></a>
                    <a href='https://bitter-crane-65f.notion.site/K-e92b55d2ff8e456aad42df11d3f1b9ea?pvs=4' className='icon' ><img src={notionIcon} alt='notion' /></a>
                </div>
            </header>
        </section>
    )
}

export default Navbar
